// Single source for the exchange the dashboard reads.
// Flip HL_NETWORK to "mainnet" and set HL_WALLET to the real account
// before the live run. History pages and open positions all use this.
export const HL_NETWORK = "mainnet"; // "testnet" | "mainnet"

export const HL_WALLET = "0x06C4c9D6a751A07CF00B061b5802B1ac9a6F209f";

export const HL_URL = HL_NETWORK === "mainnet"
  ? "https://api.hyperliquid.xyz/info"
  : "https://api.hyperliquid-testnet.xyz/info";

export const HL_APP_URL = HL_NETWORK === "mainnet"
  ? "https://app.hyperliquid.xyz/"
  : "https://app.hyperliquid-testnet.xyz/";

export const RAILWAY_URL = "https://worker-production-ae46.up.railway.app";

export async function hlPost(body) {
  const res = await fetch(HL_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  return res.json();
}
